import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoTrello = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 114 48'
    {...props}
  >
    <g clipPath='url(#Logo_Trello_svg__a)'>
      <path
        fill='url(#Logo_Trello_svg__b)'
        fillRule='evenodd'
        d='M20.56 12H3.305a2.69 2.69 0 0 0-2.69 2.687v17.228a2.69 2.69 0 0 0 2.68 2.703h17.268a2.69 2.69 0 0 0 2.686-2.694V14.687A2.69 2.69 0 0 0 20.56 12M10.377 28.29a.9.9 0 0 1-.903.896H5.7a.896.896 0 0 1-.891-.895V17.069a.895.895 0 0 1 .891-.896h3.772a.9.9 0 0 1 .895.896zm8.7-5.152a.896.896 0 0 1-.895.896H14.4a.9.9 0 0 1-.895-.896v-6.07a.9.9 0 0 1 .895-.895h3.771a.895.895 0 0 1 .892.896z'
        clipRule='evenodd'
      />
      <path
        fill='#293856'
        d='M47.512 13.657v4.374h-5.181v16.587h-4.997V18.03h-5.181v-4.374zM53.87 34.618h-4.619V18.302h4.62v3.124c.877-2.201 2.28-3.51 4.778-3.35v4.833c-3.263-.254-4.779.544-4.779 3.158zM83.884 34.745c-3.027 0-4.931-1.45-4.931-4.88V12h4.652v17.225c0 .99.65 1.341 1.45 1.341q.345.007.69-.033v4.021a6.8 6.8 0 0 1-1.86.19M93.588 34.745c-3.027 0-4.934-1.45-4.934-4.88V12h4.651v17.225c0 .99.656 1.341 1.469 1.341q.344.007.685-.033v4.021a6.8 6.8 0 0 1-1.87.19M97.688 26.453c0-5.04 2.901-8.488 7.896-8.488 4.996 0 7.836 3.437 7.836 8.488S110.548 35 105.585 35c-4.964 0-7.897-3.54-7.897-8.547m4.528 0c0 2.454 1.03 4.402 3.369 4.402 2.338 0 3.31-1.948 3.31-4.402s-.998-4.351-3.31-4.351-3.369 1.893-3.369 4.351M64.885 27.928q1.941.213 3.894.228c3.539 0 6.526-.95 6.526-4.376 0-3.325-3.07-5.823-6.765-5.823-4.975 0-8.162 3.608-8.162 8.648 0 5.232 2.748 8.339 8.96 8.339a14.9 14.9 0 0 0 5.395-.964V30.07c-1.596.511-3.39 1.019-5.232 1.019-2.473 0-4.197-.812-4.616-3.162m3.56-6.41c1.31 0 2.36.888 2.36 2.103 0 1.562-1.648 2.052-3.549 2.052a16 16 0 0 1-2.415-.192c.06-.762.28-1.503.642-2.176a3.42 3.42 0 0 1 2.962-1.779z'
      />
    </g>
    <defs>
      <linearGradient
        id='Logo_Trello_svg__b'
        x1={11.931}
        x2={11.931}
        y1={34.618}
        y2={12}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0052CC' />
        <stop offset={1} stopColor='#2684FF' />
      </linearGradient>
      <clipPath id='Logo_Trello_svg__a'>
        <path fill='#fff' d='M.615 0h113v48h-113z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoTrello;
